import { useQuery } from '@tanstack/react-query';
import { getContacts } from '../../api/apiContacts';
import i18next from 'i18next';

export const useGetContacts = (params = {}) => {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ['contacts', params, i18next.language],
        queryFn: () => getContacts(params),
        retry: false,
    });

    const contacts = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, contacts, meta, refetch };
};